import { Component } from '@angular/core';
import { ModalService } from '../../services/modal.service';

@Component({
  selector: 'ng-casto-closet-doors-percentage',
  templateUrl: './closet-doors-percentage.component.html',
})
export class ClosetDoorsPercentageComponent {
  doorNumber: number;
  openingPercentage: number;
  neededPercentage: number;

  constructor(public modalService: ModalService) {
    this.doorNumber = this.modalService.currentDatas.doorNumber;
    this.openingPercentage = this.modalService.currentDatas.openingPercentage;
    this.neededPercentage = this.modalService.currentDatas.neededPercentage;
  }
}
